import React, { useRef, useEffect } from "react";
import OnboradingImage from "@/assets/Onboarding.png";
import Diamond from "@/assets/icons/Diamond.svg";
import OneTimeSm from "@/assets/OneTimeSm.png";
import useUserData from "@/hooks/useUserData";
import { motion } from "motion/react";
import { useOutsideClick } from "@/hooks/useOutsideClick";
import useSubscriptionModal from "@/hooks/useSubscriptionModal";

const proPlan = {
  name: "Pro",
  price: 24,
  desc: "Perfect for small teams and personal projects!",
  paymentLink: "https://buy.stripe.com/9B65kEbcofou5C2eR96AM01",
};

const customPlan = {
  name: "Custom",
  price: 0,
  desc: "Perfect for teams of any size!",
  paymentLink: "mailto:contact@usetool.bar",
};

const oneTime = {
  name: "One-time payment",
  price: 69,
  desc: "Best deal you can get!",
  paymentLink: "https://buy.stripe.com/test_9AQ4j64sifXCgRG9AC",
};

const Subscription = () => {
  const modalRef = useRef(null);
  const { user } = useUserData();
  const { toggle } = useSubscriptionModal();

  useOutsideClick(modalRef, () => {
    toggle();
  });

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        toggle();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [toggle]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed z-[100] w-screen h-screen bg-[#000]/[0.5] flex justify-center items-center"
    >
      <div
        ref={modalRef}
        className="w-[750px] bg-black/[0.8] backdrop-blur-[40px] p-[1px] rounded-[35px]"
      >
        <div className="w-full h-full rounded-[34px] border-[0.5px] border-white/[0.35] p-[7.5px] grid grid-cols-2 gap-[8px]">
          <img src={OnboradingImage} className="w-full h-full" />
          <div className="p-[20px] pt-[25px] w-full h-full flex flex-col justify-center items-center">
            <p className="text-[20px] onest-smb leading-[25.5px] text-center px-[8px]">
              Join Toolbar today!
            </p>
            <p className="text-[14px] w-[232px] onest-md leading-[21px] text-center text-white/[0.35] mt-[6px] px-[8px">
              Go with the plan that matches your needs.
            </p>

            <div className="flex flex-col gap-[8px] mt-[20px] onest-md w-full">
              <div
                onClick={() =>
                  window.open(
                    `${proPlan.paymentLink}?prefilled_email=${user.email}`,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                className="cursor-pointer relative pt-[13px] pb-[12px] px-[18px] rounded-[25px] bg-white/[0.05] overflow-hidden transition-all group"
              >
                <img
                  src={OneTimeSm}
                  className="absolute top-0 left-0 w-full h-full"
                />
                <div className="flex justify-between items-center relative z-[2]">
                  <div className="flex gap-[10px] items-center">
                    <img src={Diamond} />
                    <p className="text-[18px] leading-[21.6px] transition-all group-hover:text-white/80">
                      {proPlan.name}
                    </p>
                  </div>
                  <p className="text-[18px] leading-[21.6px]">
                    {proPlan.price}€
                  </p>
                </div>
                <p className="text-[12px] leading-[18px] text-white/[0.35] mt-[8px] relative z-[2]">
                  {proPlan.desc}
                </p>
              </div>
              <div
                className="cursor-pointer pt-[13px] pb-[12px] px-[18px] rounded-[25px] bg-white/[0.05] overflow-hidden transition-all group"
                onClick={() =>
                  window.open(
                    `${customPlan.paymentLink}?prefilled_email=${user.email}`,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <div className="flex justify-between items-center">
                  <div className="flex gap-[10px] items-center">
                    <img src={Diamond} />
                    <p className="text-[18px] leading-[21.6px] transition-all group-hover:text-white/15">
                      {customPlan.name}
                    </p>
                  </div>
                  {/* <p className="text-[18px] leading-[21.6px]">
                    ${proPlan.price}/mo
                  </p> */}
                </div>
                <p className="text-[12px] leading-[18px] text-white/[0.35] mt-[8px]">
                  {customPlan.desc}
                </p>
              </div>
            </div>

            {/* <div className="text-[14px] w-full mt-[20px] leading-[17.85px] onest-smb border-[1px] border-white/[0.1] rounded-[15px] py-[9px] flex justify-center items-center gap-[6px]">
              <p>14-day free trial</p>
              <div className="w-[4px] h-[4px] bg-white/[0.35] rounded-[50%]" />
              <p className="text-white/[0.35]">Cancel anytime</p>
            </div> */}

            <p className="text-white/[0.35] mt-[20px] onest-md w-[277px] text-center mx-auto text-[12px] leading-[18px] selection:block cursor-default">
              By selecting a plan, you agree to our{" "}
              <a
                target="_blank"
                href="https://usetool.bar/terms-and-conditions"
                className="underline hover:text-white/80 transition-all"
              >
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a
                target="_blank"
                href="https://usetool.bar/privacy-policy"
                className="underline hover:text-white/80 transition-all"
              >
                Privacy Policy.
              </a>
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Subscription;
